module.exports = __webpack_public_path__ + "img/logo.c961923c.svg";